import React, { FC } from 'react';

import { useWebp } from '@r1-frontend/shared/hooks/useWebp';

import ContentCard from '~/src/features/movix-new/ContentCard';
import { CARDS } from '~/src/features/movix-new/ShieldBlock/data';
import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';
import ShieldBackgroundImg from '~/static/images/movix-new/shield-background.png';
import ShieldBackgroundWebp from '~/static/images/movix-new/shield-background.webp';

import * as ST from './styled';

const ShieldBlock: FC = () => {
    const backgroundImage = useWebp() ? ShieldBackgroundWebp : ShieldBackgroundImg;
    const sourseBackgroundImage = useProgressiveImage(backgroundImage, { timeoutDelay: 1, hasTimeout: true });

    return (
        <ST.Wrapper>
            <ST.Background>
                <ST.ShieldBackground backgroundImg={sourseBackgroundImage}/>
                <ST.EnemyShipContainer>
                    <ST.EnemyShipImage />
                </ST.EnemyShipContainer>
            </ST.Background>
            <ST.StyledContainer>
                <ST.TextBlock>
                    <ST.YellowText>Movix — ваша виртуальная няня</ST.YellowText>
                    <ST.Title>
                        <h2>
                            Вы можете отдохнуть, потому что ваш ребёнок под присмотром
                        </h2>
                    </ST.Title>
                    <ST.Description>
                        {
                            'Просто настройте родительский контроль: поставьте пин-код \nот ' +
                            'случайных покупок детьми, а также ' +
                            'возрастное ограничение на фильмы и ТВ-каналы, чтобы ребёнок ' +
                            'не увидел лишнего.'
                        }
                    </ST.Description>
                </ST.TextBlock>
                <ST.CardsWrapper>
                    {CARDS.map(item => <ContentCard withoutDisplayColumn key={item.title} item={item} />)}
                </ST.CardsWrapper>
            </ST.StyledContainer>
        </ST.Wrapper>
    );
};

export default ShieldBlock;
